let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) {
    return;
  }

  // Delivery Timeline
  const deliveryTimelineTest = window.igData?.user.getTestGroup(
    "288bb3a2-201a-4c26-b611-7374398618de"
  );

  if (deliveryTimelineTest?.name === "Var A") {
    document.body.classList.add("c-delivery-timeline-varA");
  }

  // Most Popular Size badge test
  const mostPopularSizeTest = window.igData?.user.getTestGroup(
    "9d14e053-51de-42df-961d-b1ecdf9d5cf8"
  );

  if (mostPopularSizeTest?.name === "Var A") {
    document.body.classList.add("c-most-popular-size-varA");
  }

  // Continue Shopping Link in Cart
  const continueShoppingTest = window.igData?.user.getTestGroup(
    "8184743b-caeb-457d-9592-f480f5fbb61e"
  );

  if (continueShoppingTest?.name === "Var A - link") {
    document.body.classList.add("c-continue-shopping-varA");
  } else if (continueShoppingTest?.name === "Var B - button") {
    document.body.classList.add("c-continue-shopping-varB");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});
window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});

